<svg
  width="303"
  height="80"
  viewBox="0 0 303 80"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...$$props}
>
  <path
    fill="currentColor"
    d="M97.5324 25.9576V25.9011C97.5324 20.2494 101.923 15.6188 107.963 15.6188C114.003 15.6188 118.339 20.1929 118.339 25.8447V25.9011C118.339 31.5529 113.948 36.1835 107.908 36.1835C101.868 36.1835 97.5324 31.6094 97.5324 25.9576ZM113.832 25.9576V25.9011C113.832 22.4941 111.372 19.6517 107.903 19.6517C104.434 19.6517 102.03 22.4376 102.03 25.8447V25.9011C102.03 29.3082 104.489 32.1505 107.959 32.1505C111.428 32.1505 113.832 29.3647 113.832 25.9576Z"
  />
  <path
    fill="currentColor"
    d="M123.281 15.9576H132.368C134.633 15.9576 136.338 16.5553 137.487 17.7176C138.38 18.6259 138.83 19.7647 138.83 21.0965V21.1529C138.83 23.3694 137.653 24.7059 136.259 25.4447C138.524 26.3247 139.923 27.6894 139.923 30.3294V30.3859C139.923 34.0235 137.014 35.84 132.6 35.84H123.29V15.9576H123.281ZM134.55 21.84C134.55 20.5035 133.545 19.7929 131.725 19.7929H127.472V23.9953H131.442C133.341 23.9953 134.545 23.3694 134.545 21.8918V21.8353L134.55 21.84ZM135.638 29.7929C135.638 28.4565 134.689 27.6329 132.452 27.6329H127.477V32.0094H132.595C134.494 32.0094 135.643 31.3271 135.643 29.8494V29.7929H135.638Z"
  />
  <path
    fill="currentColor"
    d="M151.299 15.8165H155.268L163.656 35.8448H159.154L157.366 31.3836H149.089L147.301 35.8448H142.91L151.299 15.8165ZM155.829 27.5201L153.23 21.073L150.632 27.5201H155.833H155.829Z"
  />
  <path
    fill="currentColor"
    d="M167.793 15.9576H172.434L177.58 24.3671L182.726 15.9576H187.367V35.84H183.087V22.8565L177.58 31.3506H177.468L172.017 22.9412V35.84H167.797V15.9576H167.793Z"
  />
  <path
    fill="currentColor"
    d="M199.891 15.8165H203.861L212.249 35.8448H207.747L205.959 31.3836H197.682L195.894 35.8448H191.503L199.891 15.8165ZM204.421 27.5201L201.823 21.073L199.224 27.5201H204.426H204.421Z"
  />
  <path
    fill="currentColor"
    d="M98.3986 43.3882H113.299V47.3647H102.702V51.5952H112.039V55.5717H102.702V63.2705H98.3939V43.3882H98.3986Z"
  />
  <path
    fill="currentColor"
    d="M116.991 53.3835V53.327C116.991 47.6753 121.382 43.0447 127.422 43.0447C133.462 43.0447 137.797 47.6188 137.797 53.2706V53.327C137.797 58.9788 133.406 63.6094 127.366 63.6094C121.326 63.6094 116.991 59.0353 116.991 53.3835ZM133.29 53.3835V53.327C133.29 49.92 130.831 47.0776 127.361 47.0776C123.892 47.0776 121.488 49.8635 121.488 53.2706V53.327C121.488 56.7341 123.948 59.5764 127.417 59.5764C130.886 59.5764 133.29 56.7906 133.29 53.3835Z"
  />
  <path
    fill="currentColor"
    d="M142.433 54.7482V43.3835H146.741V54.6305C146.741 57.8964 148.307 59.5435 150.961 59.5435C153.615 59.5435 155.185 57.9529 155.185 54.7717V43.3788H159.492V54.5976C159.492 60.6211 156.167 63.5764 150.91 63.5764C145.652 63.5764 142.438 60.6211 142.438 54.7435L142.433 54.7482Z"
  />
  <path
    fill="currentColor"
    d="M164.995 43.3882H168.964L178.135 55.6329V43.3882H182.387V63.2705H178.724L169.247 50.6305V63.2705H165V43.3882H164.995Z"
  />
  <path
    fill="currentColor"
    d="M188.205 43.3882H195.838C201.989 43.3882 206.241 47.6799 206.241 53.2752V53.3317C206.241 58.927 201.989 63.2752 195.838 63.2752H188.205V43.3929V43.3882ZM192.513 47.3364V59.3223H195.838C199.335 59.3223 201.739 56.9082 201.739 53.3835V53.327C201.739 49.8023 199.335 47.3317 195.838 47.3317H192.513V47.3364Z"
  />
  <path
    fill="currentColor"
    d="M216.496 43.2423H220.466L228.854 63.2705H224.352L222.564 58.8094H214.287L212.499 63.2705H208.108L216.496 43.2423ZM221.026 54.9458L218.428 48.4988L215.829 54.9458H221.031H221.026Z"
  />
  <path
    fill="currentColor"
    d="M235.037 47.4211H229.081V43.3882H245.297V47.4211H239.34V63.2705H235.033V47.4211H235.037Z"
  />
  <path fill="currentColor" d="M249.91 43.3882H254.218V63.2705H249.91V43.3882Z" />
  <path
    fill="currentColor"
    d="M259.359 53.3835V53.327C259.359 47.6753 263.75 43.0447 269.79 43.0447C275.83 43.0447 280.165 47.6188 280.165 53.2706V53.327C280.165 58.9788 275.774 63.6094 269.734 63.6094C263.695 63.6094 259.359 59.0353 259.359 53.3835ZM275.659 53.3835V53.327C275.659 49.92 273.199 47.0776 269.73 47.0776C266.261 47.0776 263.857 49.8635 263.857 53.2706V53.327C263.857 56.7341 266.316 59.5764 269.785 59.5764C273.255 59.5764 275.659 56.7906 275.659 53.3835Z"
  />
  <path
    fill="currentColor"
    d="M285.112 43.3882H289.082L298.253 55.6329V43.3882H302.505V63.2705H298.841L289.364 50.6305V63.2705H285.112V43.3882Z"
  />
  <path
    fill="currentColor"
    d="M78.3566 45.0259C78.6114 43.1624 78.7411 41.52 78.7411 40.0047C78.7411 28.96 74.9059 19.5106 67.2263 11.7224C59.5097 3.91059 50.2553 0 39.3937 0C28.495 0 19.2174 3.91059 11.5286 11.7224C3.84905 19.5106 0 28.96 0 40.0047C0 41.6847 0.1019 43.3976 0.32886 45.1482C5.5304 43.2847 10.8477 41.8682 16.3689 40.8329H16.4847C16.9571 33.9482 19.2869 28.3906 23.4695 24.1459C27.7724 19.7741 32.974 17.5718 39.0648 17.5718C45.1557 17.5718 50.3526 19.7741 54.637 24.1459C58.9632 28.5082 61.1216 33.8118 61.1216 40V40.5459C61.6265 40.6306 62.136 40.7341 62.6084 40.8282C68.0137 41.8259 73.257 43.2235 78.3612 45.0165"
  />
  <path
    fill="currentColor"
    d="M74.3594 58.4423C75.0773 57.2141 75.6517 55.8541 76.1936 54.3623L73.8684 53.9341H73.8082C68.7364 53.0776 63.3634 52.5882 57.7126 52.5035L55.5171 52.447C48.9121 52.5317 42.3766 53.0776 35.8874 54.1364L30.6072 55.0682C22.1541 56.7858 14.1642 59.1905 6.71619 62.24C8.71714 65.2847 11.1257 68.0564 13.9557 70.4847C18.532 68.3388 23.4139 66.4047 28.6108 64.6635L29.9402 64.24C31.8624 63.5764 33.5669 63.0729 35.0861 62.6729C45.605 59.8117 55.8274 58.3011 65.7766 58.1553H66.9994C68.3519 58.1553 70.2834 58.2211 72.8401 58.3576L74.3687 58.4423H74.3594Z"
  />
  <path
    fill="currentColor"
    d="M76.0222 50.7389L77.1756 51.0259L77.9259 47.793C72.4882 46 66.8466 44.6024 61.0475 43.6283C54.0535 42.433 46.8047 41.8353 39.3428 41.8353C31.8578 41.8353 24.5719 42.433 17.5964 43.6283C11.7834 44.5977 6.15576 45.9953 0.699463 47.793C1.27381 50.5977 2.06122 53.2424 3.06169 55.7412C12.9877 51.9294 23.5761 49.4494 34.7804 48.2871C37.3789 48.0236 39.315 47.8541 40.6351 47.793L42.0524 47.713C44.2016 47.633 46.3044 47.5812 48.3888 47.5812H48.9353C52.2795 47.5812 55.9108 47.713 59.8525 48.0236C65.5682 48.5742 70.9458 49.4824 76.0269 50.7389"
  />
  <path
    fill="currentColor"
    d="M26.1328 75.8494L23.9744 76.96C28.8332 78.9929 33.9189 80 39.2687 80C45.92 80 52.1498 78.4235 57.8932 75.3129C63.558 72.207 68.1898 67.9153 71.8072 62.5317C64.614 62.9929 57.2077 64.3341 49.5235 66.527C41.5846 68.8094 33.7938 71.92 26.1328 75.8541"
  />
</svg>
